var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5053 10.7458C9.489 11.5361 8.2119 12.0067 6.82492 12.0067C3.51028 12.0067 0.823242 9.31891 0.823242 6.00335C0.823242 2.68779 3.51028 0 6.82492 0C10.1395 0 12.8266 2.68779 12.8266 6.00335C12.8266 7.39059 12.3562 8.66794 11.5662 9.6845L14.6032 12.7186C14.8963 13.0115 14.8966 13.4867 14.6038 13.7799C14.311 14.0731 13.836 14.0734 13.5429 13.7805L10.5053 10.7458ZM11.3262 6.00335C11.3262 8.49002 9.31089 10.5059 6.82492 10.5059C4.33894 10.5059 2.32366 8.49002 2.32366 6.00335C2.32366 3.51668 4.33894 1.50084 6.82492 1.50084C9.31089 1.50084 11.3262 3.51668 11.3262 6.00335Z",
    fill: "#868FA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6c2556719f0869e81a100d2d3bc33d68.svg";
export { ForwardRef as ReactComponent };